/**
* Practice location switching. This is global to the app and strategized by account.location.preferences
* locationsEnabled boolean
*/

import React from 'react';
import { withRouter } from 'react-router';
import { array, object, oneOfType, func } from 'prop-types';
import { find, propEq } from 'ramda';
import Select from 'react-select';

import cx from 'classnames';
import s from './LocationSwitcher.css';


const LocationSwitcher = ({ ...props }) => {

  const switchLocationsRequest = selectedLocation => {

    const newLocation = selectedLocation;
    // Do not want to send label with this object, just id and externalId
    // If we delete the label in handleChange() and the user cancels, <Select /> loses the label for display.
    delete newLocation.label;

    const successCallback = () => {
      props.handleLocationSelectionEnd();
      props.router.replace('/home');
    };

    const errorCallback = () => props.handleLocationSelectionEnd();

    props.closeConfirmDialog();

    // Call start callback()
    props.handleLocationSelectionStart();

    props.switchLocation(newLocation, successCallback, errorCallback);

  };

  const handleChange = location => {

    let newLocation = find(propEq('id', location.id))(props.locations);

    props.openConfirmDialog({
      title: 'Change Location',
      content: 'If you have any unsaved changes, they will be lost if you change to a different location. Do you still want to change location?',
      cancelLabel: 'No',
      cancelCallback: props.closeConfirmDialog,
      okLabel: 'Yes',
      okCallback: () => {
        switchLocationsRequest(newLocation);
      },
    });

  };

  const renderSwitcher = () => {
    return (
      <Select
        className={cx(s.control, 'schedulingFilter')}
        searchable={false}
        clearable={false}
        placeholder={props.activeLocation.name}
        optionClassName='schedulingFilter__option'
        options={props.locations}
        value={props.activeLocation.id}
        onChange={handleChange}
        inputProps={{title:'Locations', 'aria-label': 'select a practice location'}}
      />
    );
  };

  return (
    <section id="locations_dropdown" className={s.component}>
      <p className={s.header}>
        Locations
      </p>
      {renderSwitcher()}
    </section>
  );

};

LocationSwitcher.propTypes = {
  activeLocation: object,
  closeConfirmDialog: func,
  handleLocationSelectionStart: func,
  handleLocationSelectionEnd: func,
  locations: oneOfType([
    array,
    object,
  ]).isRequired,
  openConfirmDialog: func,
  router: object,
  routes: array,
  switchLocation: func,
};

export default withRouter(LocationSwitcher);



// WEBPACK FOOTER //
// ./src/components/LocationSwitcher/LocationSwitcher.js